import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  TextField,
  FormControl,
  Tooltip,
  Box,
  Typography,
  IconButton,
  Autocomplete,
  Chip,
  InputAdornment,
  Checkbox,
  FormControlLabel,
  CircularProgress,
  Button,
} from "@mui/material";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import PhoneIcon from "@mui/icons-material/Phone";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { Controller } from "react-hook-form";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import {
  ListboxComponent,
  NoDataOptionField,
} from "../../../../static/staticdata";
import {
  AccountCircleRounded,
  AddRounded,
  BusinessRounded,
  FolderRounded,
} from "@mui/icons-material";
import { useDialog } from "../../../DialogContext";
import ContactMiniForm from "../../Contacts/Contact Forms/ContactMiniForm";
import {
  debounce,
  generateUniqueMatterName,
  pageScrollStyle,
} from "../../../../styles/styles";
import noOption from "../../../../assets/no-option-found.webp";
import {
  getAllFilterContacts,
  getAllTags,
} from "../../../../redux/Apps/Lawyerapp/ContactSlice/ContactSlice";
import { getCases } from "../../../../redux/Apps/Lawyerapp/CaseSlice/CaseSlice";
import { getAlldocCategory } from "../../../../redux/Apps/Lawyerapp/DocumentSlice/DocumentSlice";
import ServiceTimeForm from "../../Activities/ActivitiesForms/ServiceTimeForm";
import ExpenseForm from "../../Activities/ActivitiesForms/ExpenseForm";
import { getActivities } from "../../../../redux/Apps/Lawyerapp/ActivitySlice/ActivitySlice";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import AttachMoneyRoundedIcon from "@mui/icons-material/AttachMoneyRounded";
import CreateTaskForm from "../../../../pages/LawyerPages/Task/TaskModuleForms/CreateTaskForm";
import CreateTaskTypeForm from "../../../../pages/LawyerPages/Task/TaskModuleForms/CreateTaskTypeForm";
import CreateTaskListForm from "../../../../pages/LawyerPages/Task/TaskModuleForms/CreateTaskListForm";

export const CustomTextarea = ({
  name,
  placeholder,
  maxLength,
  value,
  onChange,
  onBlur,
  required,
  disabled,
  readonly,
  rows = 2,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        "& textarea": {
          width: "100%",
          height: "2.5rem",
          padding: "8px 12px",
          borderRadius: "4px",
          fontSize: "0.875rem",
          fontFamily: "Roboto, sans-serif",
          border: "1px solid rgba(0, 0, 0, 0.23)",
          outline: "none",
          backgroundColor: disabled ? "#f5f5f5" : "#fff",
          color: disabled ? "rgba(0, 0, 0, 0.6)" : "inherit",
          boxShadow: "0px 0px 1px rgba(0,0,0,0.1)",
          transition: "border 0.3s ease",
          resize: "vertical",
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "4px",
            "&:hover": {
              background: "#555",
            },
          },
        },
      }}
    >
      <textarea
        id={name}
        name={name}
        placeholder={placeholder}
        maxLength={maxLength}
        value={value || ""}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        disabled={disabled}
        readOnly={readonly}
        rows={rows}
      />
    </Box>
  );
};

const InputFields = ({
  field,
  className,
  width = "100%",
  control,
  errors,
  register,
  isPreview = false,
  onAddButtonClick,
  addButtonText = "Add New",
  showAddButton = false,
  AddFormComponent,
  createDialogTitle = "Create New",
}) => {
  const listRef = useRef(null);
  const { showDialog } = useDialog();
  const [apiOptions, setApiOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useSelector((data) => data.user);
  const [searchText, setSearchText] = useState("");
  const [nextUrl, setNextUrl] = useState(null);

  const {
    label,
    field_type,
    name,
    value,
    placeholder,
    maxLength,
    required,
    tooltip,
    tooltipText,
    readonly,
    disabled,
    pickList = {
      options: [
        { label: "Option 1", value: "option_1" },
        { label: "Option 2", value: "option_2" },
      ],
    },
    rows,
    multiple,
    id,
  } = field;

  const hasApiUrl = pickList?.link_option?.tab_api;

  useEffect(() => {
    if (hasApiUrl && !isPreview) {
      const fetchOptions = async () => {
        setIsLoading(true);
        try {
          const response = await axios.get(pickList.link_option.tab_api, {
            headers: {
              Authorization: `Token ${token}`,
            },
          });
          const formattedOptions = formatApiResponse({
            res: response?.data?.results,
            tabName: pickList?.link_option?.tab,
            api: pickList?.link_option?.tab_api,
          });
          setApiOptions(
            Array.isArray(formattedOptions) ? formattedOptions : []
          );
          setNextUrl(response?.data?.next);
        } catch (error) {
          console.error("Error fetching picklist options:", error);
          setApiOptions([]);
        } finally {
          setIsLoading(false);
        }
      };
      fetchOptions();
    }
  }, [hasApiUrl, pickList?.link_option?.tab_api, isPreview]);

  const options =
    hasApiUrl && !isPreview
      ? apiOptions
      : pickList?.options || [
          { label: "Option 1", value: "option_1" },
          { label: "Option 2", value: "option_2" },
        ];

  const formatApiResponse = (data) => {
    console.log("API Response Data:", data);
    console.log("API URL:", data?.api);

    if (data?.api && data?.tabName === "contact") {
      if (Array.isArray(data?.res)) {
        return data?.res?.map((item) => {
          console.log("Contact item:", item);

          let label = "-";
          if (
            item?.contact_type === "person" &&
            (item?.first_name || item?.last_name)
          ) {
            const firstName = item?.first_name || "";
            const lastName = item?.last_name || "";
            label = `${firstName} ${lastName}`.trim();
          } else if (item?.contact_type === "company" && item?.company_name) {
            label = item?.company_name;
          } else if (
            item?.contact_type === "company" &&
            (item?.name || item?.business_name || item?.organization_name)
          ) {
            label =
              item?.name || item?.business_name || item?.organization_name;
          } else if (item?.first_name || item?.last_name) {
            const firstName = item?.first_name || "";
            const lastName = item?.last_name || "";
            label = `${firstName} ${lastName}`.trim();
          } else if (item?.company_name || item?.name) {
            label = item?.company_name || item?.name;
          }

          return {
            label: label || "-",
            contact_type: item?.contact_type ?? "unknown",
            value: item?.id.toString(),
          };
        });
      }
    } else if (data?.api && data?.tabName === "member") {
      if (Array.isArray(data?.res)) {
        return data?.res?.map((item) => {
          let label = "-";
          if (item?.first_name || item?.last_name) {
            const firstName = item?.first_name || "";
            const lastName = item?.last_name || "";
            label = `${firstName} ${lastName}`.trim();
          }

          return {
            label: label || "-",
            value: item?.id.toString(),
          };
        });
      }
    }

    return [];
  };

  const fetchOptionsWithSearch = async (
    searchQuery = "",
    isLoadMore = false
  ) => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const baseUrl = pickList.link_option.tab_api;
      const url = new URL(baseUrl);
      if (searchQuery) {
        url.searchParams.set("search", searchQuery);
      }

      let response;

      if (isLoadMore && nextUrl) {
        // Use nextUrl for pagination
        response = await axios.get(nextUrl, {
          headers: { Authorization: `Token ${token}` },
        });
      } else {
        response = await axios.get(url.toString(), {
          headers: { Authorization: `Token ${token}` },
        });
      }

      const formattedOptions = formatApiResponse({
        res: response?.data?.results,
        tabName: pickList?.link_option?.tab,
        api: pickList?.link_option?.tab_api,
      });

      const safeFormatted = Array.isArray(formattedOptions)
        ? formattedOptions
        : [];

      if (isLoadMore) {
        setApiOptions((prev) => [...prev, ...safeFormatted]);
      } else {
        setApiOptions(safeFormatted);
      }

      setNextUrl(response?.data?.next);
    } catch (error) {
      console.error("Error fetching picklist options:", error);
      setApiOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fieldId = id;
  const isMultiSelect = multiple || pickList?.multiSelect;

  const handleScroll = async (e) => {
    if (isPreview) return;

    const listNode = e.currentTarget;

    if (
      !isLoading &&
      nextUrl &&
      listNode.scrollTop + listNode.clientHeight >= listNode.scrollHeight - 50
    ) {
      await fetchOptionsWithSearch(searchText, true); // Use the new function
    }
  };

  const handleCreateNew = () => {
    if (AddFormComponent) {
      showDialog(<AddFormComponent />, {
        dialogTitle: createDialogTitle,
      });
    } else if (onAddButtonClick) {
      onAddButtonClick();
    }
  };

  // Adornment helpers
  const getStartAdornment = () => {
    if (field_type === "email") {
      return (
        <EmailRoundedIcon
          sx={{ fontSize: "1.2rem", color: "text.secondary" }}
        />
      );
    } else if (field_type === "phone") {
      return <PhoneIcon sx={{ fontSize: "1.2rem", color: "text.secondary" }} />;
    }
    return null;
  };

  const getEndAdornment = () => {
    if (field_type === "currency") {
      return (
        <AttachMoneyIcon sx={{ fontSize: "1.2rem", color: "text.secondary" }} />
      );
    } else if (field_type === "percent") {
      return (
        <PercentIcon sx={{ fontSize: "1.2rem", color: "text.secondary" }} />
      );
    }
    return null;
  };

  const ListboxComponent = (props) => {
    const { children, ...rest } = props;

    const handleButtonClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      handleCreateNew();
    };

    return (
      <Box sx={{ position: "relative" }}>
        <Box {...rest} sx={{ overflowY: "auto", maxHeight: "300px" }}>
          {children}
        </Box>
        {hasApiUrl &&
          !isPreview &&
          showAddButton &&
          (onAddButtonClick || AddFormComponent) && (
            <Box
              sx={{
                position: "sticky",
                bottom: 0,
                borderTop: "1px solid #e5e5e5",
                backgroundColor: "white",
                p: 1,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                onClick={handleButtonClick}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                variant="text"
                size="small"
                color="primary"
                endIcon={<AddRounded />}
                sx={{
                  pointerEvents: "auto",
                  zIndex: 1,
                }}
              >
                {addButtonText}
              </Button>
            </Box>
          )}
      </Box>
    );
  };

  const hasStartAdornment = !!getStartAdornment();
  const hasEndAdornment = !!getEndAdornment();

  // Common props for input fields
  const getCommonInputProps = () => ({
    id: fieldId,
    name: name,
    placeholder,
    required,
    disabled: disabled || isPreview,
    size: "small",
    fullWidth: true,
    error: !!errors?.[fieldId],
    helperText: errors?.[fieldId]?.message,
    InputProps: {
      readOnly: readonly || isPreview,
      ...(hasStartAdornment && {
        startAdornment: (
          <InputAdornment
            position="start"
            sx={{
              ml: "-0.9rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: "0.5rem",
              borderRight: "1px solid #e0e0e0",
            }}
          >
            {getStartAdornment()}
          </InputAdornment>
        ),
      }),
      ...(hasEndAdornment && {
        endAdornment: (
          <InputAdornment
            position="end"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: "0.5rem",
              borderLeft: "1px solid #e0e0e0",
              mr: "-0.9rem",
            }}
          >
            {getEndAdornment()}
          </InputAdornment>
        ),
      }),
    },
  });

  // Validation rules
  const getValidationRules = (fieldType) => {
    const commonRules = {
      required: required && !isPreview ? "This field is required" : false,
    };

    if (isPreview) return {}; // No validation in preview mode

    const rules = { ...commonRules };
    switch (fieldType) {
      case "email":
        rules.pattern = {
          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          message: "Invalid email address",
        };
        break;
      case "phone":
        rules.pattern = {
          value: /^[0-9+-\s()]*$/,
          message: "Invalid phone number",
        };
        break;
      case "number":
      case "decimal":
      case "long_integer":
      case "currency":
        rules.pattern = {
          value: /^-?\d*\.?\d*$/,
          message: "Must be a valid number",
        };
        break;
      case "percent":
        rules.pattern = {
          value: /^-?\d*\.?\d*$/,
          message: "Must be a valid number",
        };
        rules.max = {
          value: 100,
          message: "Percentage cannot exceed 100%",
        };
        rules.min = {
          value: 0,
          message: "Percentage cannot be negative",
        };
        break;
    }

    return rules;
  };

  // Get default value based on field type
  const getDefaultValue = () => {
    if (isPreview) {
      switch (field_type) {
        case "check_box":
          return false;
        case "pick_list":
          return isMultiSelect ? [] : "";
        case "date":
        case "date_time":
          return null;
        default:
          return "";
      }
    }

    switch (field_type) {
      case "check_box":
        return false;
      case "pick_list":
        return isMultiSelect ? [] : "";
      case "date":
      case "date_time":
        return null;
      default:
        return "";
    }
  };

  // Render field component
  const renderField = () => {
    const commonRules = getValidationRules(field_type);
    const defaultValue = getDefaultValue();

    switch (field_type) {
      case "single_line":
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={commonRules}
            render={({ field: hookFormField }) => (
              <TextField
                {...hookFormField}
                {...getCommonInputProps()}
                type="text"
                inputProps={{ maxLength: field.characterLimit || maxLength }}
                variant="outlined"
              />
            )}
          />
        );

      case "multi_line":
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={commonRules}
            render={({ field: hookFormField }) => (
              <CustomTextarea
                {...hookFormField}
                name={fieldId}
                placeholder={placeholder}
                maxLength={field.characterLimit || maxLength}
                required={required}
                disabled={disabled || isPreview}
                readonly={readonly || isPreview}
                rows={rows || 2}
              />
            )}
          />
        );

      case "email":
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={commonRules}
            render={({ field: hookFormField }) => (
              <TextField
                {...hookFormField}
                {...getCommonInputProps()}
                type="email"
                inputProps={{ maxLength }}
                variant="outlined"
              />
            )}
          />
        );

      case "phone":
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={commonRules}
            render={({ field: hookFormField }) => (
              <TextField
                {...hookFormField}
                {...getCommonInputProps()}
                type="tel"
                inputProps={{ maxLength }}
                variant="outlined"
              />
            )}
          />
        );

      case "pick_list":
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={commonRules}
            render={({ field: hookFormField }) => (
              <Autocomplete
                {...hookFormField}
                multiple={isMultiSelect}
                options={options}
                loading={isLoading && !isPreview}
                disabled={disabled || isPreview}
                readOnly={readonly || isPreview}
                getOptionLabel={(option) => {
                  if (typeof option === "string") return option;
                  return option.label || "";
                }}
                isOptionEqualToValue={(option, val) => {
                  if (typeof option === "object" && typeof val === "object") {
                    return option.value === val.value;
                  }
                  if (typeof option === "object" && typeof val === "string") {
                    return option.value === val;
                  }
                  return option === val;
                }}
                inputValue={searchText}
                onInputChange={(_, value) => {
                  setSearchText(value || "");
                  if (hasApiUrl && !isPreview) {
                    debounce(value || "");
                  }
                }}
                ListboxProps={{
                  onScroll: handleScroll,
                  ref: listRef,
                  style: { maxHeight: "300px" },
                }}
                ListboxComponent={ListboxComponent}
                noOptionsText={
                  <NoDataOptionField
                    imgSrc={noOption}
                    text={"Ooops there is not Data to show"}
                    btnText={addButtonText}
                    handleClickNoData={handleCreateNew}
                  />
                }
                disablePortal={false}
                PopperProps={{
                  container: document.body,
                  sx: { zIndex: 14000 },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={placeholder}
                    size="small"
                    required={required}
                    error={!!errors?.[fieldId]}
                    helperText={errors?.[fieldId]?.message}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {isLoading && !isPreview ? (
                            <CircularProgress color="primary" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                renderOption={(props, option, state) =>
                  option?.contact_type ? (
                    renderContactOption(props, option)
                  ) : (
                    <li {...props} key={option.value}>
                      {option?.label}
                    </li>
                  )
                }
                renderTags={(tagValue, getTagProps) =>
                  tagValue?.map((option, index) => (
                    <Chip
                      label={typeof option === "object" ? option.label : option}
                      size="small"
                      {...getTagProps({ index })}
                      key={`chip-${index}`}
                    />
                  ))
                }
                onChange={(_, newValue) => {
                  if (isPreview) return; // Don't handle changes in preview mode

                  if (isMultiSelect) {
                    const values = newValue.map((item) =>
                      typeof item === "object" ? item.value : item
                    );
                    hookFormField.onChange(values);
                  } else {
                    const value = newValue
                      ? typeof newValue === "object"
                        ? newValue.value
                        : newValue
                      : "";
                    hookFormField.onChange(value);
                  }
                }}
                value={(() => {
                  if (isMultiSelect) {
                    if (
                      !hookFormField.value ||
                      !Array.isArray(hookFormField.value)
                    )
                      return [];
                    return hookFormField.value.map((val) => {
                      const matchingOption = options.find(
                        (opt) => opt.value === val
                      );
                      return matchingOption || val;
                    });
                  } else {
                    if (!hookFormField.value) return null;
                    const matchingOption = options.find(
                      (opt) => opt.value === hookFormField.value
                    );
                    return matchingOption || hookFormField.value;
                  }
                })()}
              />
            )}
          />
        );

      case "date":
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={commonRules}
            render={({ field: hookFormField }) => (
              <DatePicker
                {...hookFormField}
                value={hookFormField.value || null}
                onChange={(date) => !isPreview && hookFormField.onChange(date)}
                disabled={disabled || isPreview}
                readOnly={readonly || isPreview}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                    required: required,
                    error: !!errors?.[fieldId],
                    helperText: errors?.[fieldId]?.message,
                  },
                  popper: {
                    sx: {
                      zIndex: 1600,
                    },
                  },
                }}
                format="MM/DD/YYYY"
              />
            )}
          />
        );

      case "date_time":
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={commonRules}
            render={({ field: hookFormField }) => (
              <DateTimePicker
                {...hookFormField}
                value={hookFormField.value || null}
                onChange={(date) => !isPreview && hookFormField.onChange(date)}
                disabled={disabled || isPreview}
                readOnly={readonly || isPreview}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                    required: required,
                    error: !!errors?.[fieldId],
                    helperText: errors?.[fieldId]?.message,
                  },
                  popper: {
                    sx: {
                      zIndex: 1600,
                    },
                  },
                }}
                format="MM/DD/YYYY hh:mm A"
              />
            )}
          />
        );

      case "number":
      case "decimal":
      case "long_integer":
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={commonRules}
            render={({ field: hookFormField }) => (
              <TextField
                {...hookFormField}
                {...getCommonInputProps()}
                type="number"
                inputProps={{
                  maxLength,
                  step: field_type === "decimal" ? "0.01" : "1",
                }}
                variant="outlined"
              />
            )}
          />
        );

      case "currency":
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={commonRules}
            render={({ field: hookFormField }) => (
              <TextField
                {...hookFormField}
                {...getCommonInputProps()}
                type="number"
                inputProps={{
                  maxLength,
                  step: "0.01",
                }}
                variant="outlined"
              />
            )}
          />
        );

      case "percent":
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={commonRules}
            render={({ field: hookFormField }) => (
              <TextField
                {...hookFormField}
                {...getCommonInputProps()}
                type="number"
                inputProps={{
                  maxLength,
                  step: "0.01",
                  min: "0",
                  max: "100",
                }}
                variant="outlined"
              />
            )}
          />
        );

      case "check_box":
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={commonRules}
            render={({ field: hookFormField }) => (
              <FormControl
                fullWidth
                error={!!errors?.[fieldId]}
                sx={{
                  border: "1px solid #ddd",
                  mt: "0.45rem",
                  borderRadius: "0.2rem",
                  pl: "1rem",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      {...hookFormField}
                      checked={!!hookFormField.value}
                      disabled={disabled || isPreview}
                      readOnly={readonly || isPreview}
                      size="small"
                      onChange={(e) =>
                        !isPreview && hookFormField.onChange(e.target.checked)
                      }
                    />
                  }
                  label={placeholder || label || ""}
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: "0.8rem",
                      fontWeight: 400,
                      color:
                        disabled || isPreview
                          ? "text.disabled"
                          : "text.primary",
                    },
                  }}
                />
                {errors?.[fieldId] && (
                  <Typography color="error" variant="caption">
                    {errors[fieldId].message}
                  </Typography>
                )}
              </FormControl>
            )}
          />
        );

      default:
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={commonRules}
            render={({ field: hookFormField }) => (
              <TextField
                {...hookFormField}
                {...getCommonInputProps()}
                type={field_type || "text"}
                inputProps={{ maxLength }}
                variant="outlined"
              />
            )}
          />
        );
    }
  };

  // Special handling for checkbox field
  if (field_type === "check_box") {
    return (
      <Box className={className} sx={{ width, mt: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {renderField()}
          {tooltip && (
            <Tooltip title={tooltipText || ""} arrow placement="top">
              <IconButton size="small" sx={{ ml: 0.5, p: 0 }}>
                <HelpRoundedIcon sx={{ fontSize: "1rem" }} color="primary" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>
    );
  }

  if (!field) return null;

  // Standard field with label
  return (
    <Box className={className} sx={{ width }}>
      <FormControl fullWidth variant="outlined" size="medium">
        {label && (
          <Box sx={{ display: "flex", alignItems: "center", mb: "0.2rem" }}>
            <Typography
              variant="body1"
              component="label"
              htmlFor={fieldId}
              sx={{ fontSize: "0.8rem", fontWeight: 500 }}
            >
              {label} {required && <span style={{ color: "red" }}>*</span>}
            </Typography>

            {tooltip && (
              <Tooltip title={tooltipText || ""} arrow placement="top">
                <IconButton size="small" sx={{ ml: 0.5, p: 0 }}>
                  <HelpRoundedIcon sx={{ fontSize: "1rem" }} color="primary" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        )}

        <Box sx={{ position: "relative", width: "100%", overflow: "hidden" }}>
          {renderField()}

          {required && !isPreview && (
            <Box
              sx={{
                position: "absolute",
                top: "0rem",
                right: "0rem",
                width: "0",
                height: "0",
                borderRight: "12px solid #dc3545",
                borderBottom: "12px solid transparent",
                zIndex: 1,
              }}
            />
          )}
        </Box>
      </FormControl>
    </Box>
  );
};

export default InputFields;

const renderContactOption = (props, option) => (
  <li
    {...props}
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <Typography variant="body1">{option?.label ?? ""}</Typography>
    <Typography variant="body1">
      {option?.contact_type === "person" ? (
        <AccountCircleRoundedIcon
          sx={{ color: "#bf3fe1", fontSize: "0.9rem" }}
        />
      ) : (
        <BusinessRoundedIcon sx={{ color: "#2e77f5", fontSize: "0.9rem" }} />
      )}
    </Typography>
  </li>
);

export const ContactApiField = ({
  name,
  label,
  control,
  value,
  onChange,
  errors,
  token,
  apiUrl,
  isCompany = false,
  isRequired = false,
  renderNoOptions,
  AddcontactFunc,
  formatApiResponse,
  tabName,
  editData,
  multiple = false,
  placeholder = "Select contact",
  returnFullData = false,
  disabled = false,
  refreshKey = 0,
}) => {
  const dispatch = useDispatch();
  const { showDialog } = useDialog();
  const [apiOptions, setApiOptions] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedContact, setSelectedContact] = useState(multiple ? [] : null);

  const debouncedSearch = useCallback(
    debounce(async (query) => {
      await fetchContacts(query);
    }, 300),
    [apiUrl, token, formatApiResponse, tabName]
  );

  const getNextPage = (nextUrl) => {
    if (!nextUrl) return 1;
    const url = new URL(nextUrl);
    return parseInt(url.searchParams.get("page")) || 1;
  };

  // Default format function if none provided
  const defaultFormatApiResponse = (data) => {
    if (!data.res || !Array.isArray(data.res)) {
      console.warn("Invalid data structure:", data);
      return [];
    }

    return data.res.map((item) => ({
      id: item.id,
      first_name: item.first_name || "",
      last_name: item.last_name || "",
      company_name: item.company_name || "",
      contact_type: item.contact_type || "person",
      // Add any other fields you need
      ...item,
    }));
  };

  const fetchContacts = async (searchQuery = "", isLoadMore = false) => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const result = await dispatch(
        getAllFilterContacts({
          url: apiUrl,
          token,
          page: isLoadMore ? getNextPage(nextUrl) : 1,
          search: searchQuery,
        })
      ).unwrap();

      // Use provided formatApiResponse or default one
      const formatFunction = formatApiResponse || defaultFormatApiResponse;

      const formatted = formatFunction({
        res: result.results || [],
        tabName,
        api: apiUrl,
      });

      // Validate formatted data
      if (!Array.isArray(formatted)) {
        console.error(
          "formatApiResponse must return an array, got:",
          typeof formatted
        );
        setApiOptions([]);
        return;
      }

      // Check if formatted data has required fields
      const hasValidStructure = formatted.every(
        (item) => item && typeof item === "object" && item.id !== undefined
      );

      if (!hasValidStructure) {
        console.error(
          "Formatted data missing required fields (id):",
          formatted
        );
      }

      // Handle editData
      if (editData && typeof editData === "object" && editData.id) {
        const exists = formatted.find((c) => c.id === editData.id);
        if (!exists) {
          const formattedEditData = {
            id: editData.id,
            first_name: editData.first_name || "",
            last_name: editData.last_name || "",
            company_name: editData.company_name || "",
            contact_type: editData.contact_type || "person",
            ...editData,
          };
          setApiOptions((prev) => [
            formattedEditData,
            ...(isLoadMore ? prev : []),
            ...formatted,
          ]);
        } else {
          setApiOptions((prev) =>
            isLoadMore ? [...prev, ...formatted] : formatted
          );
        }
      } else {
        setApiOptions((prev) =>
          isLoadMore ? [...prev, ...formatted] : formatted
        );
      }

      // Handle pagination
      setNextUrl(result.next || result.pagination?.nextPage || null);
    } catch (err) {
      console.error("Fetch contacts error:", err);
      setApiOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  useEffect(() => {
    if (control) return; // when using react-hook-form the value is managed externally

    if (value && apiOptions.length > 0) {
      if (multiple && Array.isArray(value)) {
        const vals = value
          .map((v) =>
            typeof v === "object" ? v : apiOptions.find((o) => o.id === v)
          )
          .filter(Boolean);
        setSelectedContact(vals);
      } else if (!multiple) {
        const found =
          typeof value === "object"
            ? value
            : apiOptions.find((o) => o.id === value);
        setSelectedContact(found || null);
      }
    } else if (!value) {
      setSelectedContact(multiple ? [] : null);
    }
  }, [value, apiOptions, multiple, control]);

  const handleInputChange = (_, value) => {
    setSearchText(value);
    debouncedSearch(value);
  };

  const handleScroll = (e) => {
    const node = e.currentTarget;
    if (
      !isLoading &&
      nextUrl &&
      node.scrollTop + node.clientHeight >= node.scrollHeight - 50
    ) {
      fetchContacts(searchText, true);
    }
  };

  const getOptionLabel = (option) => {
    if (!option) return "";
    if (option.company_name) {
      return `${option.company_name}`;
    }
    if (option.first_name) {
      return `${option.first_name} ${option.last_name || ""}`.trim();
    }

    return option.company_name || `Contact ${option.id}` || "";
  };

  const handleSelectionChange = (event, newValue, fieldOnChange) => {
    if (multiple) {
      setSelectedContact(newValue || []);
      const values = returnFullData
        ? newValue || []
        : (newValue || []).map((opt) => opt?.id).filter(Boolean);
      if (typeof fieldOnChange === "function") fieldOnChange(values);
      if (onChange) onChange(values);
    } else {
      setSelectedContact(newValue || null);
      const val = returnFullData ? newValue || null : newValue?.id || null;
      if (typeof fieldOnChange === "function") fieldOnChange(val);
      if (onChange) onChange(val);
    }
  };

  const commonProps = {
    multiple,
    fullWidth: true,
    options: apiOptions,
    inputValue: searchText,
    onInputChange: handleInputChange,
    loading: isLoading,
    disabled,
    getOptionLabel,
    isOptionEqualToValue: (option, value) => {
      if (!option || !value) return false;
      return option.id === value.id;
    },
    ListboxProps: {
      onScroll: handleScroll,
      style: { maxHeight: "250px", overflowY: "auto" },
    },
    noOptionsText: renderNoOptions || (
      <Typography variant="body2">
        {isLoading ? "Loading..." : "No options found"}
      </Typography>
    ),
    renderInput: (params) => (
      <TextField
        {...params}
        label={
          <span>
            {label}
            {isRequired && <span style={{ color: "red" }}> *</span>}
          </span>
        }
        placeholder={placeholder}
        size="small"
        fullWidth
        error={Boolean(errors?.[name])}
        helperText={errors?.[name]?.message}
        InputProps={{
          ...params.InputProps,
          startAdornment:
            !multiple && selectedContact ? (
              <Chip
                size="small"
                sx={{
                  bgcolor:
                    selectedContact?.contact_type === "person"
                      ? "#bf3fe1"
                      : "#2e77f5",
                  color: "#fff",
                }}
                label={
                  <Typography variant="body1">
                    {selectedContact?.contact_type === "person" ? (
                      <AccountCircleRoundedIcon
                        sx={{ color: "#fff", fontSize: "0.9rem" }}
                      />
                    ) : (
                      <BusinessRoundedIcon
                        sx={{ color: "#fff", fontSize: "0.9rem" }}
                      />
                    )}
                  </Typography>
                }
              />
            ) : null,
          endAdornment: (
            <>
              {isLoading && <CircularProgress color="primary" size={20} />}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
      />
    ),
    ListboxComponent: (props) => {
      const { children, ...rest } = props;
      return (
        <Box sx={{ position: "relative" }}>
          <Box {...rest} sx={{ ...pageScrollStyle }}>
            {children}
          </Box>
          {AddcontactFunc && (
            <Box
              sx={{
                position: "sticky",
                bottom: 0,
                borderTop: "1px solid #e5e5e5",
                backgroundColor: "white",
                p: 1,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  showDialog(<ContactMiniForm defaultType="company" />, {
                    dialogTitle: "Create company contact",
                  });
                }}
                variant="text"
                size="small"
                color="primary"
                endIcon={<AddRounded />}
              >
                {isCompany ? "Add Company" : "Add Contact"}
              </Button>
            </Box>
          )}
        </Box>
      );
    },
    renderOption: (props, option) => (
      <li
        {...props}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="body1">{getOptionLabel(option)}</Typography>
        <Box>
          {option?.contact_type === "person" ? (
            <AccountCircleRounded
              sx={{ fontSize: "0.9rem", color: "#bf3fe1" }}
            />
          ) : (
            <BusinessRounded sx={{ fontSize: "0.9rem", color: "#2e77f5" }} />
          )}
        </Box>
      </li>
    ),
  };

  if (control && name) {
    return (
      <Controller
        name={name}
        control={control}
        rules={isRequired ? { required: `Please fill ${label}` } : {}}
        render={({ field }) => {
          const controlValue = multiple
            ? (field.value || [])
                .map((v) =>
                  typeof v === "object" ? v : apiOptions.find((o) => o.id === v)
                )
                .filter(Boolean)
            : typeof field.value === "object"
            ? field.value
            : apiOptions.find((o) => o.id === field.value) || null;

          return (
            <Autocomplete
              {...commonProps}
              value={controlValue}
              onChange={(e, newVal) =>
                handleSelectionChange(e, newVal, field.onChange)
              }
              disablePortal={false}
              PopperProps={{ container: document.body, sx: { zIndex: 14000 } }}
            />
          );
        }}
      />
    );
  }
  return (
    <FormControl fullWidth size="small">
      <Autocomplete
        {...commonProps}
        value={selectedContact}
        onChange={handleSelectionChange}
        disablePortal={false}
        PopperProps={{ container: document.body, sx: { zIndex: 14000 } }}
      />
    </FormControl>
  );
};

export const MatterApiField = ({
  name,
  label = "Matter",
  value,
  onChange,
  errors,
  token,
  apiUrl,
  isRequired = false,
  renderNoOptions,
  AddMatterFunc,
  formatApiResponse,
  defaultValue = null,
  editData = null,
  MatterFormComponent,
  createMatterDialogTitle = "Create Matter",
  noDataText = "Oops! Looks like there are no matters to display",
  addButtonText = "Add Matter",
  placeholder = "Select matter",
  generateUniqueMatterName,
  returnFullData = false,
  disabled = false,
}) => {
  const dispatch = useDispatch();
  const { showDialog } = useDialog();
  const [apiOptions, setApiOptions] = useState([]);
  const [selectedMatter, setSelectedMatter] = useState(null);
  const [nextUrl, setNextUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (editData) {
      setApiOptions((prevOptions) => {
        const existingIds = prevOptions.map((option) => option.id);
        if (!existingIds.includes(editData.id)) {
          return [editData, ...prevOptions];
        }
        return prevOptions;
      });
      setSelectedMatter(editData);
    }
  }, [editData]);

  useEffect(() => {
    if (value && apiOptions.length > 0) {
      const selectedOption = apiOptions.find((option) =>
        returnFullData ? option.id === value?.id : option.id === value
      );
      if (selectedOption) {
        setSelectedMatter(selectedOption);
      }
    } else if (!value) {
      setSelectedMatter(null);
    }
  }, [value, apiOptions, returnFullData]);

  const debouncedSearch = useCallback(
    debounce(async (query) => {
      await fetchMatters(query);
    }, 300),
    [apiUrl, token, formatApiResponse]
  );

  const getNextPage = (nextUrl) => {
    if (!nextUrl) return 1;
    const url = new URL(nextUrl);
    return parseInt(url.searchParams.get("page")) || 1;
  };

  const fetchMatters = async (searchQuery = "", isLoadMore = false) => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const result = await dispatch(
        getCases({
          url: apiUrl,
          token,
          page: isLoadMore ? getNextPage(nextUrl) : 1,
          search: searchQuery,
        })
      ).unwrap();

      const resultsData = result?.results || [];

      const formatted = formatApiResponse
        ? formatApiResponse({
            res: resultsData,
            api: apiUrl,
          })
        : resultsData;

      const safeFormatted = Array.isArray(formatted) ? formatted : [];

      if (isLoadMore) {
        setApiOptions((prev) => [...(prev || []), ...safeFormatted]);
      } else {
        const combinedOptions = [...safeFormatted];

        if (
          editData &&
          !combinedOptions.find((option) => option.id === editData.id)
        ) {
          combinedOptions.unshift(editData);
        }

        setApiOptions(combinedOptions);
      }

      const paginationData = result?.pagination || {};
      setNextUrl(paginationData.next || null);
    } catch (err) {
      console.error("Fetch matters error:", err);
      setApiOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMatters();
  }, []);

  const handleInputChange = (_, value) => {
    setSearchText(value || "");
    debouncedSearch(value || "");
  };

  const handleMatterSelectionChange = (_, newValue) => {
    setSelectedMatter(newValue);
    if (onChange) {
      if (returnFullData) {
        onChange(newValue);
      } else {
        onChange(newValue?.id || null);
      }
    }
  };

  const handleScroll = (e) => {
    const node = e.currentTarget;
    if (
      !isLoading &&
      nextUrl &&
      node.scrollTop + node.clientHeight >= node.scrollHeight - 50
    ) {
      fetchMatters(searchText, true);
    }
  };

  const handleCreateMatter = () => {
    if (MatterFormComponent) {
      showDialog(<MatterFormComponent />, {
        dialogTitle: createMatterDialogTitle,
      });
    } else if (AddMatterFunc) {
      AddMatterFunc();
    }
  };

  const ListboxComponent = (props) => {
    const { children, ...rest } = props;
    return (
      <Box sx={{ position: "relative" }}>
        <Box {...rest} sx={{ overflowY: "auto", ...pageScrollStyle }}>
          {children}
        </Box>
        {(AddMatterFunc || MatterFormComponent) && (
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              borderTop: "1px solid #e5e5e5",
              backgroundColor: "white",
              p: 1,
              display: "flex",
              justifyContent: "flex-end",
            }}
            onMouseDown={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <Button
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleCreateMatter();
              }}
              variant="text"
              size="small"
              color="primary"
              endIcon={<AddRounded />}
              zindex={1}
            >
              {addButtonText}
            </Button>
          </Box>
        )}
      </Box>
    );
  };

  return (
    <FormControl fullWidth size="small">
      <Autocomplete
        fullWidth
        disabled={disabled}
        options={Array.isArray(apiOptions) ? apiOptions : []}
        inputValue={searchText}
        value={selectedMatter}
        onInputChange={handleInputChange}
        onChange={handleMatterSelectionChange}
        loading={isLoading}
        getOptionLabel={(option) => {
          if (!option) return "";
          return generateUniqueMatterName
            ? generateUniqueMatterName(option.id, option.case_name)
            : `${option.id}-${option.case_name || ""}`;
        }}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        ListboxProps={{
          onScroll: handleScroll,
          style: { maxHeight: "250px", overflowY: "auto" },
        }}
        noOptionsText={
          renderNoOptions || (
            <NoDataOptionField
              imgSrc={noOption}
              text={noDataText}
              btnText={addButtonText}
              handleClickNoData={handleCreateMatter}
            />
          )
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={
              <span>
                {label}
                {isRequired && <span style={{ color: "red" }}> *</span>}
              </span>
            }
            placeholder={placeholder}
            size="small"
            fullWidth
            error={Boolean(errors?.[name])}
            helperText={errors?.[name]?.message}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {isLoading && <CircularProgress color="primary" size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        ListboxComponent={ListboxComponent}
        disablePortal={false}
        PopperProps={{ container: document.body, sx: { zIndex: 14000 } }}
        renderOption={(props, option) => (
          <li
            {...props}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 16px",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <Typography variant="body2" fontWeight="medium">
                {generateUniqueMatterName(option.id, option.case_name)}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {option?.case_status}
              </Typography>
            </Box>
          </li>
        )}
      />
    </FormControl>
  );
};

export const DocCategoryApiField = ({
  name,
  label = "Category",
  value,
  onChange,
  errors,
  token,
  apiUrl,
  isRequired = false,
  renderNoOptions,
  AddCategoryFunc,
  formatApiResponse,
  defaultValue = null,
  editData = null,
  CategoryFormComponent,
  createCategoryDialogTitle = "Create Category",
  noDataText = "Oops! Looks like there are no categories to display",
  addButtonText = "Add Category",
  placeholder = "Select category",
}) => {
  const dispatch = useDispatch();
  const { showDialog } = useDialog();
  const [apiOptions, setApiOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [nextUrl, setNextUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  // Handle editData
  useEffect(() => {
    if (editData) {
      setApiOptions((prevOptions) => {
        const existingIds = prevOptions.map((option) => option.id);
        if (!existingIds.includes(editData.id)) {
          return [editData, ...prevOptions];
        }
        return prevOptions;
      });
      setSelectedCategory(editData);
    }
  }, [editData]);

  // Set initial selected category based on value prop
  useEffect(() => {
    if (value && apiOptions.length > 0) {
      const selectedOption = apiOptions.find((option) => option.id === value);
      if (selectedOption) {
        setSelectedCategory(selectedOption);
      }
    } else if (!value) {
      setSelectedCategory(null);
    }
  }, [value, apiOptions]);

  const debouncedSearch = useCallback(
    debounce(async (query) => {
      await fetchCategories(query);
    }, 300),
    [apiUrl, token, formatApiResponse]
  );

  const getNextPage = (nextUrl) => {
    if (!nextUrl) return 1;
    const url = new URL(nextUrl);
    return parseInt(url.searchParams.get("page")) || 1;
  };

  const fetchCategories = async (searchQuery = "", isLoadMore = false) => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const result = await dispatch(
        getAlldocCategory({
          url: apiUrl,
          token,
          page: isLoadMore ? getNextPage(nextUrl) : 1,
          // pageSize: 50,
          search: searchQuery,
        })
      ).unwrap();

      const resultsData = result?.results || result || [];

      const formatted = formatApiResponse
        ? formatApiResponse({
            res: resultsData,
            api: apiUrl,
          })
        : resultsData;

      const safeFormatted = Array.isArray(formatted) ? formatted : [];

      if (isLoadMore) {
        setApiOptions((prev) => [...(prev || []), ...safeFormatted]);
      } else {
        const combinedOptions = [...safeFormatted];

        if (
          editData &&
          !combinedOptions.find((option) => option.id === editData.id)
        ) {
          combinedOptions.unshift(editData);
        }

        setApiOptions(combinedOptions);
      }

      // Handle pagination if your API returns pagination info
      const paginationData = result?.pagination || {};
      setNextUrl(paginationData.next || null);
    } catch (err) {
      console.error("Fetch categories error:", err);
      setApiOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleInputChange = (_, value) => {
    setSearchText(value || "");
    debouncedSearch(value || "");
  };

  const handleCategorySelectionChange = (_, newValue) => {
    setSelectedCategory(newValue);
    if (onChange) {
      onChange(newValue?.id || null);
    }
  };

  const handleScroll = (e) => {
    const node = e.currentTarget;
    if (
      !isLoading &&
      nextUrl &&
      node.scrollTop + node.clientHeight >= node.scrollHeight - 50
    ) {
      fetchCategories(searchText, true);
    }
  };

  const handleCreateCategory = () => {
    if (CategoryFormComponent) {
      showDialog(<CategoryFormComponent />, {
        dialogTitle: createCategoryDialogTitle,
      });
    } else if (AddCategoryFunc) {
      AddCategoryFunc();
    }
  };

  const ListboxComponent = (props) => {
    const { children, ...rest } = props;
    return (
      <Box sx={{ position: "relative" }}>
        <Box {...rest} sx={{ overflowY: "auto", ...pageScrollStyle }}>
          {children}
        </Box>
        {(AddCategoryFunc || CategoryFormComponent) && (
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              borderTop: "1px solid #e5e5e5",
              backgroundColor: "white",
              p: 1,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleCreateCategory();
              }}
              variant="text"
              size="small"
              color="primary"
              endIcon={<AddRounded />}
            >
              {addButtonText}
            </Button>
          </Box>
        )}
      </Box>
    );
  };

  return (
    <FormControl fullWidth size="small">
      <Autocomplete
        fullWidth
        options={Array.isArray(apiOptions) ? apiOptions : []}
        inputValue={searchText}
        value={selectedCategory}
        onInputChange={handleInputChange}
        onChange={handleCategorySelectionChange}
        loading={isLoading}
        getOptionLabel={(option) => {
          if (!option) return "";
          return option.category_name || "";
        }}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        ListboxProps={{
          onScroll: handleScroll,
          style: { maxHeight: "250px", overflowY: "auto" },
        }}
        noOptionsText={
          renderNoOptions || (
            <NoDataOptionField
              imgSrc={noOption}
              text={noDataText}
              btnText={addButtonText}
              handleClickNoData={handleCreateCategory}
            />
          )
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={
              <span>
                {label}
                {isRequired && <span style={{ color: "red" }}> *</span>}
              </span>
            }
            placeholder={placeholder}
            size="small"
            fullWidth
            error={Boolean(errors?.[name])}
            helperText={errors?.[name]?.message}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {isLoading && <CircularProgress color="primary" size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        ListboxComponent={ListboxComponent}
        disablePortal={false}
        PopperProps={{ container: document.body, sx: { zIndex: 14000 } }}
        renderOption={(props, option) => (
          <li
            {...props}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 16px",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <Typography variant="body2" fontWeight="medium">
                {option.category_name}
              </Typography>
              {option?.description && (
                <Typography variant="caption" color="textSecondary">
                  {option.description}
                </Typography>
              )}
            </Box>
          </li>
        )}
      />
    </FormControl>
  );
};

export const ActivityApiField = ({
  name,
  label = "Activity",
  control,
  value,
  onChange,
  errors,
  token,
  apiUrl,
  isRequired = false,
  renderNoOptions,
  formatApiResponse,
  tabName,
  editData = null,
  multiple = true,
  placeholder = "Select activity",
  returnFullData = false,
  disabled = false,
  refreshKey = 0,
}) => {
  const dispatch = useDispatch();
  const { showDialog } = useDialog();
  const [apiOptions, setApiOptions] = useState([]);
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchActivities(searchText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshKey, apiUrl, token]);

  const debouncedSearch = useCallback(
    debounce(async (query) => {
      await fetchActivities(query);
    }, 300),
    [apiUrl, token, formatApiResponse, tabName]
  );

  const getNextPage = (url) => {
    if (!url) return 1;
    const u = new URL(url);
    return parseInt(u.searchParams.get("page")) || 1;
  };

  const fetchActivities = async (searchQuery = "", isLoadMore = false) => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const result = await dispatch(
        getActivities({
          url: apiUrl,
          token,
          page: isLoadMore ? getNextPage(nextUrl) : 1,
          search: searchQuery,
        })
      ).unwrap();

      const resultsData = result?.results || [];

      const formatted = formatApiResponse
        ? formatApiResponse({ res: resultsData, tabName, api: apiUrl })
        : resultsData;

      const safeFormatted = Array.isArray(formatted) ? formatted : [];

      if (isLoadMore) {
        setApiOptions((prev) => [...(prev || []), ...safeFormatted]);
      } else {
        const combinedOptions = [...safeFormatted];
        if (
          editData &&
          !combinedOptions.find((option) => option.id === editData.id)
        ) {
          combinedOptions.unshift(editData);
        }
        setApiOptions(combinedOptions);
      }

      const paginationData = result?.pagination || {};
      setNextUrl(paginationData.next || null);
    } catch (err) {
      console.error("Fetch activities error:", err);
      setApiOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (value && apiOptions.length > 0) {
      const selected = multiple
        ? (value || [])
            .map((v) =>
              typeof v === "object" ? v : apiOptions.find((o) => o.id === v)
            )
            .filter(Boolean)
        : typeof value === "object"
        ? value
        : apiOptions.find((o) => o.id === value) || null;
      setSelectedActivities(selected);
    } else if (!value) {
      setSelectedActivities(multiple ? [] : null);
    }
  }, [value, apiOptions, multiple]);

  const handleInputChange = (_, val) => {
    setSearchText(val);
    debouncedSearch(val);
  };

  const handleSelectionChange = (e, newVal, fieldOnChange) => {
    setSelectedActivities(newVal);
    const val = returnFullData
      ? newVal
      : (newVal || []).map((opt) => opt?.id).filter(Boolean);
    if (typeof fieldOnChange === "function") fieldOnChange(val);
    if (onChange) onChange(val);
  };

  const handleScroll = (e) => {
    const node = e.currentTarget;
    if (
      !isLoading &&
      nextUrl &&
      node.scrollTop + node.clientHeight >= node.scrollHeight - 50
    ) {
      fetchActivities(searchText, true);
    }
  };

  // Fixed button handlers with proper event handling
  const handleAddTimeEntry = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      showDialog(<ServiceTimeForm />, { dialogTitle: "New Time Entry" });
    } catch (error) {
      console.error("Error opening time entry dialog:", error);
    }
  };

  const handleAddExpenseEntry = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      showDialog(<ExpenseForm />, { dialogTitle: "New Expense Entry" });
    } catch (error) {
      console.error("Error opening expense entry dialog:", error);
    }
  };

  const NoOptionContent = (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
        position: "relative",
        zIndex: 1000,
      }}
    >
      <Box sx={{ height: "6rem" }}>
        <img
          src={noOption}
          alt="No Data"
          style={{ height: "100%", width: "100%", objectFit: "contain" }}
          onError={(e) => {
            e.onerror = null;
            e.target.src = require("../../../../assets/no-option-found.webp");
          }}
        />
      </Box>
      <Typography
        variant="body1"
        sx={{ fontSize: "0.9rem", textAlign: "center" }}
      >
        No activities found
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          variant="contained"
          size="small"
          onClick={handleAddTimeEntry}
          sx={{
            pointerEvents: "auto",
            zIndex: 1001,
          }}
        >
          Add time entry
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={handleAddExpenseEntry}
          sx={{
            pointerEvents: "auto",
            zIndex: 1001,
          }}
        >
          Add expense entry
        </Button>
      </Box>
    </Box>
  );

  // Fixed ListboxComponent with proper event handling
  const ListboxComponent = React.forwardRef((props, ref) => {
    const { children, ...rest } = props;

    return (
      <Box ref={ref} sx={{ position: "relative" }}>
        <Box
          {...rest}
          sx={{
            ...pageScrollStyle,
            paddingBottom: "60px", // Add padding to prevent content overlap
          }}
        >
          {children}
        </Box>
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            borderTop: "1px solid #e5e5e5",
            backgroundColor: "white",
            p: 1,
            display: "flex",
            gap: 1,
            justifyContent: "flex-end",
            zIndex: 9999,
            boxShadow: "0 -2px 4px rgba(0,0,0,0.1)",
          }}
          // Prevent the autocomplete from closing when clicking in this area
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <Button
            variant="text"
            size="small"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleAddTimeEntry(e);
            }}
            sx={{
              pointerEvents: "auto",
              zIndex: 10000,
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            Add time entry
          </Button>
          <Button
            variant="text"
            size="small"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleAddExpenseEntry(e);
            }}
            sx={{
              pointerEvents: "auto",
              zIndex: 10000,
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            Add expense entry
          </Button>
        </Box>
      </Box>
    );
  });

  const commonProps = {
    multiple,
    fullWidth: true,
    options: Array.isArray(apiOptions) ? apiOptions : [],
    inputValue: searchText,
    onInputChange: handleInputChange,
    loading: isLoading,
    disabled,
    getOptionLabel: (option) => option?.description || option?.type || "",
    isOptionEqualToValue: (option, value) => option?.id === value?.id,
    ListboxProps: {
      onScroll: handleScroll,
      style: {
        maxHeight: "250px",
        overflowY: "auto",
        position: "relative",
      },
    },
    noOptionsText: renderNoOptions || NoOptionContent,
    renderInput: (params) => (
      <TextField
        {...params}
        label={
          <span>
            {label}
            {isRequired && <span style={{ color: "red" }}> *</span>}
          </span>
        }
        placeholder={placeholder}
        size="small"
        fullWidth
        error={Boolean(errors?.[name])}
        helperText={errors?.[name]?.message}
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {isLoading && <CircularProgress color="primary" size={20} />}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
      />
    ),
    ListboxComponent,
    disableCloseOnSelect: true,
    // Modified onClose to handle button clicks better
    onClose: (event, reason) => {
      // Don't close if clicking on buttons or within the button container
      if (reason === "blur" || reason === "selectOption") {
        const target = event?.target;
        if (
          target?.closest(".MuiButton-root") ||
          target?.closest("[data-button-container]")
        ) {
          return false;
        }
      }
    },
    renderOption: (props, option) => (
      <li
        {...props}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "10px 14px",
          borderBottom: "1px solid #eee",
          cursor: "pointer",
          transition: "background 0.2s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#f9f9f9")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
      >
        {/* Top Row */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            width: "100%",
            mb: 0.5,
          }}
        >
          {/* Icon */}
          {option?.type === "time" ? (
            <AccessTimeRoundedIcon
              sx={{ fontSize: 16, color: "primary.main" }}
            />
          ) : (
            <AttachMoneyRoundedIcon
              sx={{ fontSize: 16, color: "success.main" }}
            />
          )}

          {/* Description */}
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 600,
              flex: 1,
              fontSize: "0.9rem",
              color: "text.primary",
            }}
          >
            {option?.description || "No description"}
          </Typography>

          {/* Amount */}
          <Chip
            label={`₹${option?.total_payment || "0.00"}`}
            size="small"
            color={option?.type === "time" ? "primary" : "success"}
            variant="outlined"
            sx={{ fontSize: "0.75rem" }}
          />
        </Box>

        {/* Category */}
        {option?.category && (
          <Box sx={{ pl: 3, mb: 0.5 }}>
            <Chip
              label={option.category.name}
              size="small"
              variant="outlined"
              color="default"
              sx={{ height: 20, fontSize: "0.7rem" }}
            />
          </Box>
        )}

        {/* Middle Row - Details */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            pl: 3,
            flexWrap: "wrap",
            color: "text.secondary",
            fontSize: "0.75rem",
          }}
        >
          {option?.type === "time" && option?.time_in && option?.time_out && (
            <Typography variant="caption">
              {new Date(option.time_in).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}{" "}
              -{" "}
              {new Date(option.time_out).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </Typography>
          )}

          {option?.type === "expense" && option?.quantity && (
            <Typography variant="caption">Qty: {option.quantity}</Typography>
          )}

          {option?.hourly_rate && (
            <Typography variant="caption">
              Rate: ₹{option.hourly_rate}
              {option?.type === "time" ? "/hr" : ""}
            </Typography>
          )}

          {option?.created_at && (
            <Typography variant="caption">
              {new Date(option.created_at).toLocaleDateString()}
            </Typography>
          )}
        </Box>

        {/* Status Chips */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            pl: 3,
            mt: 0.5,
            flexWrap: "wrap",
          }}
        >
          {option?.non_billable && (
            <Chip
              label="Non-billable"
              size="small"
              color="warning"
              variant="outlined"
            />
          )}
          {option?.is_paid && (
            <Chip label="Paid" size="small" color="success" variant="filled" />
          )}
          {option?.bill_genrated && (
            <Chip label="Billed" size="small" color="info" variant="outlined" />
          )}
          {!option?.bill_entry_show && (
            <Chip label="Hidden from bill" size="small" variant="outlined" />
          )}
        </Box>

        {/* Case / Lawyer Info */}
        {(option?.lawyer || option?.case) && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: "100%",
              pl: 3,
              mt: 0.5,
            }}
          >
            {option?.case?.id && (
              <Typography variant="caption" sx={{ color: "text.secondary" }}>
                {generateUniqueMatterName(
                  option.case.id,
                  option.case.case_name
                )}
              </Typography>
            )}
          </Box>
        )}
      </li>
    ),
  };

  if (control && name) {
    return (
      <Controller
        name={name}
        control={control}
        rules={isRequired ? { required: `Please fill ${label}` } : {}}
        render={({ field }) => {
          const controlValue = multiple
            ? (field.value || [])
                .map((v) =>
                  typeof v === "object" ? v : apiOptions.find((o) => o.id === v)
                )
                .filter(Boolean)
            : typeof field.value === "object"
            ? field.value
            : apiOptions.find((o) => o.id === field.value) || null;
          return (
            <Autocomplete
              {...commonProps}
              size="small"
              disablePortal={false}
              disableCloseOnSelect
              value={controlValue}
              onChange={(e, newVal) =>
                handleSelectionChange(e, newVal, field.onChange)
              }
              PopperProps={{ container: document.body, sx: { zIndex: 14000 } }}
            />
          );
        }}
      />
    );
  }

  return (
    <FormControl fullWidth size="small">
      <Autocomplete
        {...commonProps}
        size="small"
        disablePortal={false}
        disableCloseOnSelect
        value={selectedActivities}
        onChange={handleSelectionChange}
        PopperProps={{ container: document.body, sx: { zIndex: 14000 } }}
      />
    </FormControl>
  );
};


const uniqBy = (arr, key) => {
  const seen = new Set();
  return arr.filter((item) => {
    const k = item[key];
    return seen.has(k) ? false : seen.add(k);
  });
};

export const TaskApiField = ({
  name,
  label = "Task",
  control,
  value,
  onChange,
  errors,
  token,
  apiUrl,
  isRequired = false,
  multiple = false,
  renderNoOptions,
  formatApiResponse,
  placeholder = "Select task",
  returnFullData = false,
  disabled = false,
  editData = null,
  AddTaskTypeFunc,
  AddTaskFunc,
  TaskTypeFormComponent,
  TaskFormComponent,
  createTaskTypeDialogTitle = "Create Task Type",
  createTaskDialogTitle = "Create Task",
}) => {
  const { showDialog } = useDialog();
  const [apiOptions, setApiOptions] = useState([]);
  const [selected, setSelected] = useState(multiple ? [] : null);
  const [nextUrl, setNextUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  // Combine selected values with API options
  const options = useMemo(() => {
    const selectedOptions = multiple
      ? (selected || []).filter(Boolean)
      : selected
      ? [selected]
      : [];

    return uniqBy([...selectedOptions, ...apiOptions], "id");
  }, [apiOptions, selected, multiple]);

  // Set selected only when value prop changes
  useEffect(() => {
    if (multiple) {
      setSelected(Array.isArray(value) ? value : []);
    } else {
      setSelected(value || null);
    }
  }, [value, multiple]);

  const debouncedSearch = useCallback(
    debounce(async (query) => {
      await fetchOptions(query);
    }, 300),
    [apiUrl, token, formatApiResponse]
  );

  const getNextPage = (url) => {
    if (!url) return 1;
    const u = new URL(url);
    return parseInt(u.searchParams.get("page")) || 1;
  };

  const fetchOptions = async (searchQuery = "", isLoadMore = false) => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const params = [];
      if (searchQuery) params.push(`search=${encodeURIComponent(searchQuery)}`);
      const page = isLoadMore ? getNextPage(nextUrl) : 1;
      if (page) params.push(`page=${page}`);

      const url = params.length
        ? `${apiUrl}${apiUrl.includes("?") ? "&" : "?"}${params.join("&")}`
        : apiUrl;

      const res = await axios.get(url, {
        headers: { Authorization: `Token ${token}` },
      });

      const results = res.data.results || res.data || [];
      const formatted = formatApiResponse
        ? formatApiResponse({ res: results, api: apiUrl })
        : results;
      const safe = Array.isArray(formatted) ? formatted : [];

      if (isLoadMore) {
        setApiOptions((prev) => [...prev, ...safe]);
      } else {
        setApiOptions(safe);
      }

      setNextUrl(res.data.next || null);
    } catch (err) {
      console.error("Fetch tasks error:", err);
      setApiOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, [apiUrl, token]);

  const handleInputChange = (_, val) => {
    setSearchText(val);
    debouncedSearch(val);
  };

  const handleSelectionChange = (e, newVal, fieldOnChange) => {
    setSelected(newVal);

    const val = returnFullData
      ? newVal
      : multiple
      ? (newVal || []).map((o) => o?.id).filter(Boolean)
      : newVal?.id || null;

    if (typeof fieldOnChange === "function") fieldOnChange(val);
    if (onChange) onChange(val);
  };

  const handleScroll = (e) => {
    const node = e.currentTarget;
    if (
      !isLoading &&
      nextUrl &&
      node.scrollTop + node.clientHeight >= node.scrollHeight - 50
    ) {
      fetchOptions(searchText, true);
    }
  };

  const handleCreateTaskType = () => {
    if (TaskTypeFormComponent) {
      showDialog(<TaskTypeFormComponent />, {
        dialogTitle: createTaskTypeDialogTitle,
      });
    } else if (AddTaskTypeFunc) {
      AddTaskTypeFunc();
    }
  };

  const handleCreateTask = () => {
    if (TaskFormComponent) {
      showDialog(<TaskFormComponent />, {
        dialogTitle: createTaskDialogTitle,
      });
    } else if (AddTaskFunc) {
      AddTaskFunc();
    }
  };

  const ListboxComponent = (props) => {
    const { children, ...rest } = props;
    return (
      <Box sx={{ position: "relative" }}>
        <Box
          {...rest}
          onScroll={handleScroll}
          sx={{ overflowY: "auto", maxHeight: "250px" }}
        >
          {children}
        </Box>
        {(AddTaskTypeFunc ||
          AddTaskFunc ||
          TaskTypeFormComponent ||
          TaskFormComponent) && (
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              borderTop: "1px solid #e5e5e5",
              backgroundColor: "white",
              p: 1,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 1,
            }}
            onMouseDown={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            {/* Add Task Type Button */}
            {(AddTaskTypeFunc || TaskTypeFormComponent) && (
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleCreateTaskType();
                }}
                variant="text"
                size="small"
                color="primary"
                endIcon={<AddRounded />}
              >
                Add Task Type
              </Button>
            )}

            {/* Add Task Button */}
            {(AddTaskFunc || TaskFormComponent) && (
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleCreateTask();
                }}
                variant="text"
                size="small"
                color="secondary"
                endIcon={<AddRounded />}
              >
                Add Task
              </Button>
            )}
          </Box>
        )}
      </Box>
    );
  };

  const commonProps = {
    multiple,
    fullWidth: true,
    options: options,
    inputValue: searchText,
    onInputChange: handleInputChange,
    loading: isLoading,
    disabled,
    getOptionLabel: (option) =>
      option?.task_name ||
      option?.type_name ||
      option?.name ||
      String(option?.id || ""),
    isOptionEqualToValue: (option, value) => option?.id === value?.id,
    noOptionsText: renderNoOptions || "No options",
    ListboxComponent,
    renderInput: (params) => (
      <TextField
        {...params}
        label={
          <span>
            {label}
            {isRequired && <span style={{ color: "red" }}> *</span>}
          </span>
        }
        placeholder={placeholder}
        size="small"
        fullWidth
        error={Boolean(errors?.[name])}
        helperText={errors?.[name]?.message}
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {isLoading && <CircularProgress color="primary" size={20} />}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
      />
    ),
  };

  if (control && name) {
    return (
      <Controller
        name={name}
        control={control}
        rules={isRequired ? { required: `Please fill ${label}` } : {}}
        render={({ field }) => (
          <Autocomplete
            {...commonProps}
            value={selected}
            onChange={(e, newVal) =>
              handleSelectionChange(e, newVal, field.onChange)
            }
            disablePortal={false}
            PopperProps={{ container: document.body, sx: { zIndex: 14000 } }}
          />
        )}
      />
    );
  }

  return (
    <FormControl fullWidth size="small">
      <Autocomplete
        {...commonProps}
        disablePortal={false}
        value={selected}
        onChange={(e, newVal) => handleSelectionChange(e, newVal)}
        PopperProps={{ container: document.body, sx: { zIndex: 14000 } }}
      />
    </FormControl>
  );
};
